import { isValidISODateString } from "@/lib/businessRules/settlementDateRules";
import { fetchRequestWrapper } from "@/lib/utilities";
import cpiStore, { CpiStatus } from "./cpiStore";

// LQC-2957 - GET /ReferenceData/CPI/{cpiIndex}?startDate=yyyy-MM-dd (LQC-2963).
// cpiIndex is the ZCS floating leg's reference rate code ("EUR-HICP"), which the backend
// matches against dbo.ReferenceRate. The date goes as ?startDate=: the action's parameter
// is startDate, not the route's {date} segment, so only the query string binds it.

export function returnCpiKey(cpiIndex: string, startDate?: string): string {
  return `${cpiIndex}|${startDate ?? "current"}`;
}

export function returnCpiEndpoint(cpiIndex: string, startDate?: string): string {
  const base = `/ReferenceData/CPI/${encodeURIComponent(cpiIndex)}`;
  return startDate ? `${base}?startDate=${startDate}` : base;
}

// { cpi, cpiIndex }, or no body when the index has no benchmark. Null: nothing to use.
export function extractCpi(response: any): number | null {
  return typeof response?.cpi === "number" && isFinite(response.cpi) ? response.cpi : null;
}

// Cached per index and date, failures too, so a down API is asked once.
export async function fetchCpi(
  cpiIndex: string,
  startDate: string | undefined,
  getAccessTokenSilently: Function,
): Promise<void> {
  if (!cpiIndex || (startDate && !isValidISODateString(startDate))) return;
  const key = returnCpiKey(cpiIndex, startDate);
  const store = cpiStore.getState();
  if (store.cpiByKey[key]) return;

  store.setCpi(key, { status: CpiStatus.Loading, cpi: null });
  try {
    const response = await fetchRequestWrapper(
      { url: returnCpiEndpoint(cpiIndex, startDate) },
      getAccessTokenSilently,
    );
    store.setCpi(key, { status: CpiStatus.Loaded, cpi: extractCpi(response) });
  } catch {
    store.setCpi(key, { status: CpiStatus.Error, cpi: null });
  }
}
